import { useRecoilState } from 'recoil';
import { PaReportState } from './use-report';

export function useReportRecoilState() {
  const [reportState, setReportState] = useRecoilState(PaReportState);

  return [{ reportState }, { setReportState }] as const;
}
